import React from 'react';
import { useTheme } from 'styled-components';
import { StyledScreen } from './screen.styles';
import { Loading } from '../../io/loading';

export interface ScreenProps {
    children: React.ReactNode;
    backgroundOverride?: string;
    loading?: boolean;
}

export const Screen: React.FC<ScreenProps> = ({
    children,
    backgroundOverride,
    loading = false,
}) => {
    const theme = useTheme();
    const bg = backgroundOverride || theme.background.default;
    return <StyledScreen bg={bg}>{loading ? <Loading /> : children}</StyledScreen>;
};
